import { z } from "zod";
import { RECOVERY_STATUSES } from "@/features/payroll/schemas/recovery-schedule.schema";

/// URL search params for `/$workspaceSlug/payroll/recoveries` (PAYD-FR-044,
/// FR-045, FR-125).
///
/// `q`, `status` and `member` ride the URL (S3): "Priya's outstanding
/// recoveries" is a link an admin sends a colleague. `schedule` opens one
/// schedule's detail drawer, the same way `row` opens one on the payroll
/// inputs grid. `tab` picks between the list and the arrears calculator, two
/// different lenses on the same additional-salary-generating machinery, not a
/// subset filter of each other.
export const recoverySchedulesRouteSearchSchema = z
  .object({
    tab: z.enum(["schedules", "arrears"]).optional().catch(undefined),
    q: z.string().optional().catch(undefined),
    status: z.enum(RECOVERY_STATUSES).optional().catch(undefined),
    member: z.string().optional().catch(undefined),
    schedule: z.string().optional().catch(undefined),
  })
  .strict();

export type RecoverySchedulesRouteSearch = z.infer<typeof recoverySchedulesRouteSearchSchema>;
